import React, { useEffect } from "react";
import "./waitlist.css";

const Waitlist = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://prod-waitlist-widget.s3.us-east-2.amazonaws.com/getwaitlist.min.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="waitlist-container">
      <div>
        <h1>
          Join the <span className="gradient-text">waitlist</span>
        </h1>
      </div>
      <div
        className="waitlist"
        id="getWaitlistContainer"
        data-waitlist_id="17387"
        data-widget_type="WIDGET_1"
      ></div>
      <link
        rel="stylesheet"
        type="text/css"
        href="https://prod-waitlist-widget.s3.us-east-2.amazonaws.com/getwaitlist.min.css"
      />
    </div>
  );
};

export default Waitlist;
